import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData, logout, FETCH_ROLES } from 'src/store/actions/accountActions';
import authService from 'src/services/authService';
import resolveActiveContext from 'src/store/actions/resolveActiveContext';

function Auth({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout())
      });

      try {
        const user = await authService.loginInWithToken();
        await dispatch(setUserData(user));
        try {
          await dispatch(resolveActiveContext());
        } finally {
          dispatch({ type: FETCH_ROLES });
        }
      } catch {
        // No valid session — router will redirect to /login
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any
};

export default Auth;
